// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  presenceId: __t.u64().primaryKey().name("presence_id"),
  sessionId: __t.u64().name("session_id"),
  currentTab: __t.string().name("current_tab"),
  currentRoute: __t.string().name("current_route"),
  currentViewId: __t.option(__t.string()).name("current_view_id"),
  focusedTwinId: __t.option(__t.string()).name("focused_twin_id"),
  focusedTwinDtmi: __t.option(__t.string()).name("focused_twin_dtmi"),
  selectedTwinIdsJson: __t.string().name("selected_twin_ids_json"),
  graphCenterX: __t.option(__t.f64()).name("graph_center_x"),
  graphCenterY: __t.option(__t.f64()).name("graph_center_y"),
  graphZoom: __t.option(__t.f32()).name("graph_zoom"),
  viewedStreamsJson: __t.string().name("viewed_streams_json"),
  timeRangeStart: __t.option(__t.timestamp()).name("time_range_start"),
  timeRangeEnd: __t.option(__t.timestamp()).name("time_range_end"),
  lastUpdate: __t.timestamp().name("last_update"),
});
